import { Component, OnInit, HostListener, ChangeDetectorRef,  NgZone, Output, EventEmitter} from '@angular/core';
import { isUndefined } from 'util';
import { Router } from '@angular/router';
import { FormControl} from '@angular/forms';
import { Observable } from 'rxjs';
import {map, startWith} from 'rxjs/operators';

import { environment } from '../../environments/environment';
import { PlanService } from "../shared/services/planService";
import { RestApiService } from "../shared/restApiServices/restapi.service";
import { NativeWindoRefService } from '../shared/services/native-windo-ref.service';
declare var require: any;
var countriesStateJSON = require("../../assets/StateCountry.json");

@Component({
  selector: 'app-checkout',
  templateUrl: './checkout.component.html',
  styleUrls: ['./checkout.component.css']
})

export class CheckoutComponent implements OnInit {

  notSupportedSize : boolean;
  planInfo:PlanInfoInterface;
  // planInfo = {'priceInRupee':704.5};
  companyName:string = '';
  gstNumber:string = '';
  address:any;
  options:any;
  companyNameEmpty:string = '';
  Street:string = '';
  Locality:string = '';
  City:string = '';
  Zipcode:string = '';
  state:string = '';
  Country:string = '';
  Street1:string = '';
  Locality1:string = '';
  City1:string = '';
  Zipcode1:string = '';
  state1:string = '';
  Country1:string = '';
  gstNoEmpty:string = '';
  addressEmpty:string = '';
  nativeWindow:any;
  rzp1:any;
  amountToBePaid:number;
  userName:string;
  name:string;
  date;
  subscriptionID:string;
  userInfo = {'imageUrl' : ''};
  // planName:string;
  // max_devices_per_month:string;
  // numResponses;
  countryControl = new FormControl();
  myControl = new FormControl();
  filteredCountries: Observable<any[]>;
  filteredState: Observable<any[]>;
  loader :boolean = false;
  countriesStateJSON = countriesStateJSON;
  statesJSON:any;
  @Output() cancel = new EventEmitter<string>();

  constructor(private restApiService : RestApiService,private planService:PlanService,private nativeWindoRefService: NativeWindoRefService,private router: Router,private cdr:ChangeDetectorRef, private ngZone: NgZone) {

    this.restApiService.getPlanAndAccountDetailsOfUser().subscribe(res=>{
    if(res.imageUrl)
    {
      this.userInfo.imageUrl = res.imageUrl;
    }
    else{
      this.userInfo.imageUrl = '';
    }
    });

    this.nativeWindow = nativeWindoRefService.getNativeWindow();
    if (window.screen.width < 900) {
      this.notSupportedSize = true;
    }
    else {
      this.notSupportedSize = false;
    }
    this.date = new Date();

    this.subscriptionID = this.planService.getSubscription();
   }

  ngOnInit() {
    this.planInfo = this.planService.getPlan();
    this.restApiService.getUserCheckoutDetails().subscribe(res =>{
      if(res){
        this.userName = res.userEmail;
        this.name = res.Name;
        this.companyName = res['company_name'];
        if(Boolean(res['GSTIN']))
        {
          this.gstNumber = res['GSTIN'];
        }
        else{
          this.gstNumber = '';
        }

        if(Object.getOwnPropertyNames(res.address).length !== 0)
        {
          this.Street1 = res['address']['Street'];
          this.Locality1 = res['address']['Locality'];
          this.City1 = res['address']['City'];
          this.Zipcode1 = res['address']['Zipcode'];
          this.state1 = res['address']['state'];
          this.myControl.setValue(this.state1);
          this.Country1 = res['address']['Country'];
          this.countryControl.setValue(this.Country1);
          this.selectCountry(this.Country1);
        }

      }
    });
    if(this.planInfo)
    {
      this.planInfo['priceInRupee'] = this.planInfo['price'];
    }
    this.filteredCountries = this.countryControl.valueChanges
    .pipe(
      startWith(''),
      map(value => typeof value === 'string' ? value : value['countryName']),
      map(name => name ? this._filter(name) : this.countriesStateJSON.slice())
    );
  }

  private _filter(name: string): any[] {
    const filterValue = name.toLowerCase();
    return this.countriesStateJSON.filter(option => option.countryName.toLowerCase().indexOf(filterValue) === 0);
  }

  selectCountry(country){
    this.Country1 = country;
    let index = this.countriesStateJSON.filter(option => option.countryName.toLowerCase().indexOf(country.toLowerCase()) === 0)
    this.statesJSON = index[0].regions;
    this.filteredState = this.myControl.valueChanges
    .pipe(
      startWith(''),
      map(value => typeof value === 'string' ? value : value['name']),
      map(name => name ? this._filterState(name) : this.statesJSON.slice())
    );
  }

  private _filterState(name: string): any[] {
    const filterValue = name.toLowerCase();
    return this.statesJSON.filter(option => option.name.toLowerCase().indexOf(filterValue) === 0);
  }

  selectState(state){
    this.state1 = state;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    if (event.target.innerWidth < 900) {
      this.notSupportedSize = true;
    }
    else{
      this.notSupportedSize=false;
    }
    // event.target.innerWidth;

  }

  proceed(){
    this.companyNameEmpty = '';
    this.gstNoEmpty = '';
    this.addressEmpty = '';
    this.Street = '';
    this.Locality = '';
    this.City = '';
    this.Zipcode = '';
    this.state = '';
    this.Country = '';

    if(this.companyName==null || isUndefined(this.companyName) || this.companyName=="")
    {
      this.companyNameEmpty = "on-error";
      return;
    }
    else if(this.Street1==null || isUndefined(this.Street1) || this.Street1=="")
    {
      this.Street = "on-error";
      return;
    }
    else if(this.Locality1==null || isUndefined(this.Locality1) || this.Locality1=="")
    {
      this.Locality = "on-error";
      return;
    }
    else if(this.City1==null || isUndefined(this.City1) || this.City1=="")
    {
      this.City = "on-error";
      return;
    }
    else if(this.Zipcode1==null || isUndefined(this.Zipcode1) || this.Zipcode1=="")
    {
      this.Zipcode = "on-error";
      return;
    }
    else if(this.state1==null || isUndefined(this.state1) || this.state1=="")
    {
      this.state = "on-error";
      return;
    }
    else if(this.Country1==null || isUndefined(this.Country1) || this.Country1=="")
    {
      this.Country = "on-error";
      return;
    }
    else {
      this.companyNameEmpty = '';
      this.gstNoEmpty = '';
      this.addressEmpty = '';
      this.Street = '';
      this.Locality = '';
      this.City = '';
      this.Zipcode = '';
      this.state = '';
      this.Country = '';
      this.initPay();
    }

  }

  onPayment(_self,razorpay_payment_id,razorpay_subscription_id){
    this.ngZone.run(()=>{
      this.loader = true;
    });
    let superAdminID = localStorage.getItem("superAdminID");
    if(razorpay_payment_id!=null || !isUndefined(razorpay_payment_id))
    {
      let oldSubscriptionID = this.planService.getOldSubscription();
      _self.restApiService.onPaymentSuccess(_self.planInfo['planID'],razorpay_payment_id,superAdminID,_self.planInfo['priceInRupee'],_self.companyName,_self.address,razorpay_subscription_id,oldSubscriptionID,_self.planInfo['itemID'])
      .subscribe(value => {
      this.ngZone.run(() =>{
         this.loader = false;
         this.router.navigate(['/payment-success'],
         { queryParams: { transactionID:razorpay_payment_id,amount:this.planInfo['priceInRupee']} }
         )
        });
      })
    }
  }

  navigate()
  {
    this.router.navigateByUrl('/questionnaires');
  }

  onCancel(){
    this.cancel.emit('true');
  }

  initPay():void {
    this.amountToBePaid= (this.planInfo['priceInRupee'])*100;//to be give in paise to razor pay
    let _self = this;
    var key = 'rzp_test_YGnKTM8DHUi7Hb';
    if (environment.production){
      key = 'rzp_live_1OSva5ArG3d4nt';
    }
    this.options = {
      "key": key,
      "amount": this.amountToBePaid,
      "subscription_id":this.subscriptionID,
      "name": "SurveyMan",
      "description": "Surveyor Plan Subscription",
      "image": "https://s3.ap-south-1.amazonaws.com/ankaha-assets/Ank-aha-final-logo.png",
      "prefill": {
        "name": this.name,
        "email": this.userName
      },
      "notes": {
        "address": "note value"
      },
      "theme": {
        "color": "#009D8E"
      }
    };
    this.address = {
      "companyName": this.companyName,
      "Street": this.Street1,
      "Locality":this.Locality1,
      "City": this.City1,
      "Zipcode": this.Zipcode1,
      "state": this.state1,
      "Country": this.Country1
    };

    this.options.handler = ((response) => {
      _self.onPayment(_self,response.razorpay_payment_id,response.razorpay_subscription_id);
    });

    this.rzp1 = new this.nativeWindow.Razorpay(this.options);
    this.rzp1.open();
  }

  navigateToDashBoard() {
    this.router.navigateByUrl('/questionnaires');
  }

}

export interface PlanInfoInterface {
  max_devices_per_month: number;
  subscription_info: string;
  planName: string;
  priceInRupee:number;
  numResponses:any;
  itemID:string
}



// WEBPACK FOOTER //
// ./src/app/checkout/checkout.component.ts